<template>
  <div>

      <b-field label="Sélection du projet">
        <b-autocomplete
            v-model="userInputProject"
            :data="filteredProjectsArray"
            placeholder="ex. 24BATVIT"
            icon="folder-open"
            field="fullName"
            clearable
            @select="action">
          <template #empty>Pas de résultats</template>
          <template slot-scope="props">
            <div class="media-content">
              {{ props.option.fullName }}
              <small>
                <em>( id : {{ props.option.id }} )</em>
              </small>
            </div>
          </template>
        </b-autocomplete>
      </b-field>

    </div>
</template>

<script>

export default {
  name: "SelectProject",
  mounted() {

    this.$axios.get(`getProjectsList`)
        .then(response => {
          this.projectList = response.data.allProjects;
        })
        .catch(e => {
          console.log(e);
        });

  },
  computed: {

    filteredProjectsArray() {
      return this.projectList.filter(option => {
        return option.fullName
            .toString()
            .toLowerCase()
            .indexOf(this.userInputProject.toLowerCase()) >= 0
      })
    },

  },
  watch: {
  },
  methods: {

    action(option) {
      this.selectedProject = option
      this.$emit('updateProject', option);
    }

  },
  data() {
    return {
      projectList: [],
      userInputProject: '',
      selectedProject: null,
    }
  }
}
</script>

<style scoped>

</style>
